import { MessageChannel, fromMessagePort } from '@sail/rpc';
import rpc from '../../internal/rpc/rpc';
let defaultRpcInstance;
export function getDefaultRpcInstance() {
    if (defaultRpcInstance) {
        return defaultRpcInstance;
    }
    const { port1, port2 } = new MessageChannel();
    port1.start();
    port2.start();
    defaultRpcInstance = {
        client: rpc.initClient({
            transport: fromMessagePort(port1)
        }),
        server: rpc.initServer({
            transport: fromMessagePort(port2)
        })
    };
    return defaultRpcInstance;
}

//# sourceMappingURL=defaultRpc.js.map